import {
  FirstCrownIcon,
  SecondCrownIcon,
  ThirdCrown,
} from "src/const/svgIcons";

import styles from "./RankingItem.module.scss";

export const RankingScoreIcon = ({ rank }: { rank: number }) => {
  switch (rank) {
    case 1:
      return <FirstCrownIcon className={styles.rankIcon} />;
    case 2:
      return <SecondCrownIcon className={styles.rankIcon} />;
    case 3:
      return <ThirdCrown className={styles.rankIcon} />;

    default:
      return <></>;
  }
};
